import React, {useState} from "react";
import {NahrainInput} from "../../../Common/component/NahrainInput";
import {ReactComponent as IcTextSquare} from "presentation/Common/resources/images/ic_text_square.svg";
import {useTranslation} from "react-i18next";
import {NahrainDescription} from "../../../Common/component/NahrainDescription";
import {DatePicker} from "../../../Common/component/DatePicker";
import {NahrainIncrementalInput} from "../../../Common/component/NahrainIncrementalInput";
import {NahrainPercentageInput} from "../../../Common/component/NahrainPercentageInput";
import {NahrainButton} from "../../../Common/component/NahrainButton";


export const ExamInfoDialogSidebar = ({onClickSubmitInfo}) => {
    const [t] = useTranslation("global");

    const [examInfo, setExamInfo] = useState({
        title: "",
        description: "",
        examDate: null,
        examDuration: null,
        percentage: null
    });
    const handleChange = (field, value) => {
        setExamInfo((prev) => ({...prev, [field]: value}));
    };

    return (
        <div className={`max-w-[700px] mx-auto`}>
            <h1 className={`text-xl text-onBackground font-semibold`}>{t("title_&_description")} <span
                className={`text-error`}>*</span></h1>
            <div className={`mt-4`}>
                <h1 className={`font-medium text-onBackground text-[16px]`}>{t("title")}</h1>
                <NahrainInput type={`text`} className={`mt-2`} placeholder={t("eg_network")}
                              icon={<IcTextSquare/>} onChange={(e) => handleChange("title", e)}/>

                <h1 className={`font-medium text-onBackground text-[16px] mt-4`}>{t("description")}</h1>
                <NahrainDescription className={`mt-2`} onChange={(e) => handleChange("description", e)}/>
            </div>
            <h1 className={`text-xl text-onBackground font-semibold mt-6`}>{t("date_&_duration")} <span
                className={`text-error`}>*</span></h1>
            <div className={`mt-4`}>
                <h1 className={`font-medium text-onBackground text-[16px]`}>{t("date_of_exam")}</h1>
                <DatePicker className={`mt-2`} onChange={(date) => handleChange("examDate", date)}/>
                <h1 className={`font-medium text-onBackground text-[16px] mt-4 mb-2`}>{t("duration_of_exam")}</h1>
                <NahrainIncrementalInput onChange={(value) => handleChange("examDuration", value)}/>

            </div>
            <h1 className={`text-xl text-onBackground font-semibold mt-6`}>{t("percentage_of_exam")} <span
                className={`text-error mt-6`}>*</span></h1>
            <NahrainPercentageInput className={`mt-2`} onChange={(value) => {
                handleChange("percentage", value)
            }}/>

            <div className={`sticky bg-card w-full bottom-0 py-4 mt-2`}>
                <NahrainButton onClick={() => {
                    onClickSubmitInfo(examInfo)
                }} className={`w-full`}>
                    <p className="text-2xl font-semibold">{t("continue")}</p>
                </NahrainButton>
            </div>
        </div>
    )
}